import React, { useEffect, useState } from 'react';
import axios from '../api/axiosInstance'; // ✅ utilise axios sécurisé
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import {
  Box, Typography, Button, Table, TableHead, TableRow, TableCell, TableBody,
  Paper, Alert, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';
import '../css/ManageUsers.css';
import instance from '../api/axiosInstance';

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const response = await axios.get('/users/auth/me');
        if (response.data.userType !== 'admin') {
          navigate('/404');
        } else {
          setIsAdmin(true);
        }
      } catch (error) {
        navigate('/404');
      }
    };

    checkAdmin();
  }, [navigate]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('/users');
        setUsers(response.data);
      } catch (error) {
        setError('Erreur lors de la récupération des utilisateurs');
        setTimeout(() => setError(''), 5000);
      }
    };

    if (isAdmin) fetchUsers();
  }, [isAdmin]);

  const confirmDelete = (id) => {
    setUserToDelete(id);
    setShowConfirmation(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`/users/${userToDelete}`);
      setUsers(users.filter(user => user._id !== userToDelete));
      setSuccess('Utilisateur supprimé avec succès');
      setTimeout(() => setSuccess(''), 5000);
    } catch {
      setError('Erreur lors de la suppression de l\'utilisateur');
      setTimeout(() => setError(''), 5000);
    }
    setShowConfirmation(false);
  };

  const toggleUserStatus = async (userId, newStatus) => {
  try {
    console.log("Toggling user:", userId, "to", newStatus);
    await instance.patch(`/users/${userId}/status`, { isActive: newStatus });
    setUsers(users.map(user =>
      user._id === userId ? { ...user, isActive: newStatus } : user
    ));
    setSuccess(`Utilisateur ${newStatus ? 'activé' : 'désactivé'} avec succès`);
    setTimeout(() => setSuccess(''), 5000);
  } catch (err) {
    console.error(err);
    setError("Erreur lors du changement de statut");
    setTimeout(() => setError(''), 5000);
  }
};


  const closeConfirmation = () => {
    setShowConfirmation(false);
    setUserToDelete(null);
  };

  if (!isAdmin) return null;

  return (
    <Box className="manage-users-container">
      <Sidebar />
      <Box className="main-content">
        <Typography variant="h4" gutterBottom>Gérer les utilisateurs</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <Box sx={{ mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/add-user')}
            className="add-user-button"
          >
            Ajouter un utilisateur
          </Button>
        </Box>

        <Paper className="table-container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Rôle</TableCell>
                <TableCell>Vérifié</TableCell>
                <TableCell>Code de vérification</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Société</TableCell>
               <TableCell>Statut</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
<TableBody>
  {users.map((user) => (
    <TableRow key={user._id}>
      <TableCell>{user.firstName} {user.lastName}</TableCell>
      <TableCell>{user.emailAddress}</TableCell>
      <TableCell>{user.userType}</TableCell>
      <TableCell>{user.isVerified ? 'Oui' : 'Non'}</TableCell>
      <TableCell>{user.verificationCode || 'N/A'}</TableCell>
      <TableCell>{user.arrive}</TableCell>
      <TableCell>{user.societe ? user.societe.nom : 'Aucune société'}</TableCell>
    <TableCell>{user.isActive ? '✅ Actif' : '⛔ Inactif'}</TableCell>
      <TableCell>
        <Button
          size="small"
          variant="outlined"
          onClick={() => navigate(`/edit-user/${user._id}`)}
          className="edit-button"
        >
          Modifier
        </Button>{' '}
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => confirmDelete(user._id)}
          className="delete-button"
        >
          Supprimer
        </Button>{' '}
       <Button
         size="small"
         variant="contained"
         color={user.isActive ? 'warning' : 'success'}
         onClick={() => toggleUserStatus(user._id, !user.isActive)}
       >
         {user.isActive ? 'Désactiver' : 'Activer'}
       </Button>
      </TableCell>
    </TableRow>
  ))}
</TableBody>

          </Table>
        </Paper>
      </Box>

      <Dialog open={showConfirmation} onClose={closeConfirmation}>
        <DialogTitle>Confirmation de la suppression</DialogTitle>
        <DialogContent>
          Êtes-vous sûr de vouloir supprimer cet utilisateur ?
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmation}>Non</Button>
          <Button onClick={handleDelete} color="error">Oui</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ManageUsers;
